import Api from "./Api";

class AuthDataService {
    logout = () => {
        return Api().delete(`logout`)
    }

}

export default new AuthDataService();